import { DatePicker, Form } from "antd";
import dateFnsGenerateConfig from "rc-picker/lib/generate/dateFns";
import { useRef, useState } from "react";

import CalendarEventOutlinedIcon from "~/core/ui/CustomIcons/CalendarEventIcon";

import {
  DEFAULT_DATE_RANGE_PRESET,
  SELECT_INPUT_FOCUS_DELAY,
} from "../../constants";
import { useGlobalNewOpportunityModalContext } from "../../context";
import { useInputKeyDown } from "../../hooks/useInputKeyDown";
import DDClearIcon from "../DDClearIcon";

const MyDatePicker = DatePicker.generatePicker<Date>(dateFnsGenerateConfig);
interface Props {
  name: string;
  label: string;
  placeholder?: string;
  defaultValue?: Date;
}
export default function DateWithFormItem({
  name,
  label,
  placeholder,
  defaultValue,
}: Props) {
  const ref = useRef<any>(null);

  const { handleKeyDown } = useInputKeyDown();
  const { form } = useGlobalNewOpportunityModalContext();

  const [isOpen, setIsOpen] = useState(false);
  const [hasBeenFocused, setHasBeenFocused] = useState(false);

  const value = Form.useWatch([name], form!);

  const handleDropdownClose = () => {
    setIsOpen(false);
    // Focus the select after closing
    setTimeout(() => {
      ref.current?.focus();
    }, SELECT_INPUT_FOCUS_DELAY);
  };

  return (
    <Form.Item name={name} label={label}>
      <MyDatePicker
        onOpenChange={setIsOpen}
        open={isOpen}
        ref={ref}
        format={["MM/DD/YYYY", "MM-DD-YYYY", "M/D/YYYY", "M-D-YYYY"]}
        className="!w-full"
        placeholder={placeholder}
        defaultValue={defaultValue}
        onFocus={() => {
          if (hasBeenFocused) return;
          setIsOpen(true);
          setHasBeenFocused(true);
        }}
        presets={DEFAULT_DATE_RANGE_PRESET}
        onCalendarChange={() => {
          handleDropdownClose();
        }}
        prefix={<CalendarEventOutlinedIcon className="text-light" />}
        suffixIcon={value ? <DDClearIcon asSuffix /> : null}
        allowClear={{
          clearIcon: <DDClearIcon asSuffix />,
        }}
        onKeyDown={e => {
          if (e.key === "Escape") {
            e.preventDefault();
            e.stopPropagation();
            handleDropdownClose();
          }

          handleKeyDown(e);
        }}
      />
    </Form.Item>
  );
}
